import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import MixLogo from "../../assets/images/logo.svg";

import persnal from "../../assets/images/comman/persnal-health-records.png";
import constent from "../../assets/images/comman/constent-access.png";
import digital from "../../assets/images/comman/digital-health-records.png";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";


const AbhaAbout = () => {

    const [adharNo, setAdharNo] = useState("695968714526");


    const navigate = useNavigate();

    const handlCancelABHAaddress = () => {
        navigate('/add-patient')
    }

    const { setDataByKey } = useContext(GlobalContext)
    useEffect(() => {
        setDataByKey('AdharCardNumber', adharNo)
    }, []);

    const handleCreateABHA = () => {
        // Directly navigate to Aadhar verification page
        navigate('/aadhar-abha-create');
    };

    const loginToAbha = () => {
        navigate('/login-ABHA');
    }

    // const handleContinue = (selectedType) => {
    //     if (selectedType === 'aadhaar') {
    //         navigate('/aadhar-abha-create');
    //     } else if (selectedType === 'dl') {
    //         navigate('/dl-abha-create');
    //     }
    // };


    return (
        <>
            {/* <DeactivatePopup /> */}
            <div className="mainFlow">
                <Navbar />
                <div className="container">
                    <div className="pranHealtnMainUserFlow">
                        <div className="abha-paranLogo">
                            <img src={MixLogo} />
                        </div>
                        <div className="pranAbhaHealthContent">
                            <h4>PRAN.AI Health</h4>
                            <h5>ABHA - Ayushman Bharat Health Account - Key to your digital healthcare journey.</h5>
                            <h6>Why create ABHA?</h6>
                            <p>ABHA number will establish a strong and trustable identity for you that will be accepted by healthcare providers across the country. Seamless sign up for PHR (Personal Health Records) applications such as ABDM ABHA application for Health data sharing.</p>
                            <div className="Know-more">Know more</div>
                        </div>
                        <div className="pranAiBoxes">
                            <div className="row">
                                <div className="col-xs-12 col-md-4">
                                    <div className="pranBoxes">
                                        <div className="pranBoxedImg">
                                            <img src={persnal} />
                                        </div>
                                        <h4>Personal Health Records</h4>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="pranBoxes">
                                        <div className="pranBoxedImg">
                                            <img src={constent} />
                                        </div>
                                        <h4>Consent Access</h4>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="pranBoxes">
                                        <div className="pranBoxedImg">
                                            <img src={digital} />
                                        </div>
                                        <h4>Digital Health Record</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="createAbhaBtn">
                                <button className="custBtn btnCancel" onClick={handlCancelABHAaddress}>Cancel</button>
                                <button className="custBtn btnSuccess" onClick={handleCreateABHA}>Create ABHA <i className="material-icons">arrow_right_alt</i></button>
                                <button className="custBtn btnThems" onClick={loginToAbha}>View ABHA <i className="material-icons">arrow_right_alt</i></button>
                            </div>
                        </div>
                        <div className="loginPageFooter">
                            <div className="forgotAbhaRetrive">
                                <p><a href="/forgoat-ABHA">Forgot ABHA number?</a></p>
                                <p><a href="/re-activate">Reactivate ABHA</a></p>
                                <p><a href="/findabha">Find ABHA</a></p>
                                {/* <p><a href="/retrieve-enrollment">Retrieve your Enrollment number</a></p> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />
            <Footer />

        </>
    )
}
export default AbhaAbout;